<h5 class="title">{{ title }}</h5>
<div *ngIf="icon" class="icon">
  <i [ngClass]="'fa ' + icon + ' fa-4x'"></i>
</div>
<div class="value mt">{{ value }}</div>
